import React from 'react'
import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { __t } from '../../../../i18n/t'
import { OutlineButton, PrimaryButton } from '../ui/controls'
import { C } from '../ui/tokens'

/** "Sair sem salvar?" — o foco começa em "Continuar editando", a saída segura. */
export const LeaveDialog: React.FC<{ open: boolean; onStay: () => void; onLeave: () => void }> = ({ open, onStay, onLeave }) => (
  <Dialog
    open={open}
    onClose={onStay}
    aria-labelledby="dlg-t"
    aria-describedby="dlg-d"
    slotProps={{ paper: { sx: { borderRadius: '20px', maxWidth: 440, width: '100%', m: 2, p: 1.5 } } }}
  >
    <DialogTitle id="dlg-t" sx={{ fontSize: 20, fontWeight: 700, color: C.ink }}>{__t('Sair sem salvar?')}</DialogTitle>
    <DialogContent>
      <Box id="dlg-d" sx={{ fontSize: 14.5, color: C.muted, lineHeight: 1.5 }}>{__t('O que você preencheu nesta tela será perdido.')}</Box>
    </DialogContent>
    <DialogActions sx={{ flexWrap: 'wrap', gap: 1, px: 3, pb: 2 }}>
      <OutlineButton onClick={onStay} autoFocus>{__t('Continuar editando')}</OutlineButton>
      <PrimaryButton onClick={onLeave}>{__t('Sair sem salvar')}</PrimaryButton>
    </DialogActions>
  </Dialog>
)
